<div class="header">
    <h2 mat-dialog-title>{{"PARAMETER.HEADER" | translate}}</h2>
</div>
<mat-dialog-content>
    <ng-container *ngIf="this.empty == false">
        <p>{{ "PARAMETER.CONF_DIALOG" | translate}}</p>
        <div class="table">
            <table mat-table [dataSource]="dataSet" class="table">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" #tooltip="matTooltip" matTooltip="{{element.info}}" matTooltipPosition="below">{{ element.name }}</td>
                </ng-container>
        
                <ng-container matColumnDef="curr_value">
                    <th mat-header-cell *matHeaderCellDef>{{"PARAMETER.CURRENT" | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.currentValue }} {{ element.unit}}</td>
                </ng-container>
    
                <ng-container matColumnDef="new_value">
                    <th mat-header-cell *matHeaderCellDef>{{"PARAMETER.NEW_VALUE" | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ element.chosenValue! }}</td>
                </ng-container>
    
        
                <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
            </table>
        </div>
    </ng-container>

    <ng-container *ngIf="this.empty">
        {{ "PARAMETER.CONF_MESS" | translate }}
    </ng-container>
    
</mat-dialog-content>
<mat-dialog-actions class="action">
    <button mat-button color="primary" (click)="setNewData()" [disabled]="this.empty">{{ "PARAMETER.BTN_YES" | translate }}</button>
    <button mat-button color="warn" mat-dialog-close cdkFocusInitial>{{ "PARAMETER.BTN_CANCEL" | translate }}</button>
  </mat-dialog-actions>
